import type React from 'react';
import { useMemo, useState } from 'react';
import { TrackingContext } from './tracking.context';
import type { TrackingContextValue } from './tracking.types';

interface TrackingProviderProps {
  module: string;
  screen: string;
  projectId?: string;
  projectName?: string;
  projectDurationSeconds?: number;
  children: React.ReactNode;
}

/**
 * TrackingProvider
 *
 * Declara el contexto de ubicación para todos los hijos.
 * Se puede anidar para refinar screen sin cambiar module:
 *
 *   <TrackingProvider module="Dashboard" screen="Dashboard">
 *     <TrackingProvider module="Dashboard" screen="Dashboard/PreviewModal">
 *       <PreviewModal />   ← usará screen="Dashboard/PreviewModal"
 *     </TrackingProvider>
 *   </TrackingProvider>
 */
export const TrackingProvider = ({ module, screen, projectId, projectName, children }: TrackingProviderProps) => {
  const [correlationId, setCorrelationId] = useState<string | undefined>(undefined);

  const value = useMemo<TrackingContextValue>(
    () => ({
      module,
      screen,
      projectId,
      projectName,
      correlationId,
      setCorrelationId,
    }),
    [module, screen, projectId, projectName, correlationId]
  );

  return <TrackingContext.Provider value={value}>{children}</TrackingContext.Provider>;
};
